import { ListItemIcon, styled } from '@mui/material';

import { doNotForwardTheseProps } from '@/styles/utils';

export const StatusIconContainer = styled(ListItemIcon, {
  shouldForwardProp: doNotForwardTheseProps(
    'iconColor',
    'bgColor',
    'borderColor',
    'size',
  ),
})<{
  iconColor?: string;
  bgColor?: string;
  borderColor?: string;
  size?: number;
}>(({ theme, iconColor, bgColor, borderColor, size = 48 }) => ({
  '&.MuiListItemIcon-root': {
    backgroundColor: bgColor || theme.palette.grey[200],
    border: borderColor ? `1px solid ${borderColor}` : 'none',
    borderRadius: '50%',
    minWidth: 0,
    height: size,
    width: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.MuiSvgIcon-root': {
      fill: iconColor || 'inherit',
    },
  },
}));
